(()=>{
  const pixel='1691396015650251',seen=new Set(),pending=[];
  let ready=false,started=false;
  const allowed=()=>{const p=window.Shopify?.customerPrivacy;return !!p&&p.marketingAllowed()&&p.analyticsProcessingAllowed()&&p.saleOfDataAllowed();};
  const status=(key,value)=>document.documentElement.setAttribute('data-hf-meta-'+key,String(value));
  const send=event=>{
    if(!allowed()||seen.has(event.id))return;
    if(!started){
      const n=window.fbq=window.fbq||function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments);};
      if(!n.queue){n.push=n;n.loaded=true;n.version='2.0';n.queue=[];}
      window._fbq=window._fbq||n;
      n('init',pixel);n('set','autoConfig',false,pixel);
      const script=document.createElement('script');script.async=true;script.src='https://connect.facebook.net/en_US/fbevents.js';script.dataset.heyfilterPixel=pixel;
      script.onload=()=>status('sdk','loaded');script.onerror=()=>status('sdk','blocked');document.head.appendChild(script);
      started=true;status('pixel',pixel);
    }
    const standard=['PageView','ViewContent','AddToCart','InitiateCheckout','AddPaymentInfo','Purchase','Search'];
    window.fbq(standard.includes(event.name)?'trackSingle':'trackSingleCustom',pixel,event.name,event.data,{eventID:event.id});
    seen.add(event.id);status('last-event',event.name);status('events',seen.size);
  };
  const flush=()=>{if(!ready)return;for(const event of pending.splice(0))send(event);};
  window.addEventListener('message',message=>{
    const event=message.data;
    if(!event||event.type!=='heyfilter:meta-browser:v1')return;
    if(!['PageView','ViewContent','AddToCart','InitiateCheckout','AddPaymentInfo','AddShippingInfo','Purchase','Search','ViewCart','RemoveFromCart','CheckoutContactSubmitted','CheckoutAddressSubmitted'].includes(event.name)||typeof event.id!=='string'||event.id.length>200)return;
    const frame=Array.from(document.querySelectorAll('iframe[id^="web-pixel-sandbox-CUSTOM-179437623-"]')).find(f=>f.contentWindow===message.source);
    if(!frame)return;
    message.source.postMessage({type:'heyfilter:meta-browser:ack',id:event.id},'*');
    if(ready)send(event);else if(pending.length<20)pending.push(event);
  });
  document.addEventListener('visitorConsentCollected',()=>{if(started)window.fbq('consent',allowed()?'grant':'revoke');flush();});
  const initialize=()=>{if(!window.Shopify?.loadFeatures)return;window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error=>{if(!error){ready=true;flush();}});};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
})();
